import { defineMessages } from 'react-intl';

export default defineMessages({
  ctsId: {
    id: 'sentinel.components.transferPanel.ctsId',
    defaultMessage: 'CTS ID',
  },
  fedWire: {
    id: 'sentinel.components.transferPanel.fedWire',
    defaultMessage: 'Fed Ref #',
  },
  payor: {
    id: 'sentinel.components.transferPanel.payer',
    defaultMessage: 'Payer',
  },
  beneficiary: {
    id: 'sentinel.components.transferPanel.beneficiary',
    defaultMessage: 'Beneficiary',
  },
  destination: {
    id: 'sentinel.components.transferPanel.destination',
    defaultMessage: 'Destination',
  },
  furtherCreditTo: {
    id: 'sentinel.components.transferPanel.furtherCreditTo',
    defaultMessage: 'Further Credit To',
  },
  bankIdentifierType: {
    id: 'sentinel.components.transferPanel.bankIdentifierType',
    defaultMessage: 'SWIFT / ABA',
  },
  accountName: {
    id: 'sentinel.components.transferPanel.accountName',
    defaultMessage: 'Account Name',
  },
  accountNumber: {
    id: 'sentinel.components.transferPanel.accountNumber',
    defaultMessage: 'Account Number',
  },
  bankName: {
    id: 'sentinel.components.transferPanel.bankName',
    defaultMessage: 'Bank Name',
  },
  address: {
    id: 'sentinel.components.transferPanel.address',
    defaultMessage: 'Address',
  },
  fedRefNum: {
    id: 'sentinel.components.transferPanel.fedRefNum',
    defaultMessage: 'Fed Wire Ref #',
  },
  externalId: {
    id: 'sentinel.components.transferPanel.externalId',
    defaultMessage: 'External ID',
  },
  dateCreated: {
    id: 'sentinel.components.transferPanel.dateCreated',
    defaultMessage: 'Date Created',
  },
  houseBankAccountNumber: {
    id: 'sentinel.components.transferPanel.houseBankAccountNumber',
    defaultMessage: 'House Bank Acct.',
  },
  fees: {
    id: 'sentinel.components.transferPanel.fees',
    defaultMessage: 'Fees',
  },
  isThirdParty: {
    id: 'sentinel.components.transferPanel.isThirdParty',
    defaultMessage: 'Is Third Party?',
  },
  isForeign: {
    id: 'sentinel.components.transferPanel.isForeign',
    defaultMessage: 'Is Foreign?',
  },
  wireIsReturn: {
    id: 'sentinel.components.transferPanel.wireIsReturn',
    defaultMessage: 'Wire Withdrawal Return',
  },
});



// WEBPACK FOOTER //
// ./src/components/TransferPanelWireDetails/messages.js